import { render, staticRenderFns } from "./PDFTopic.vue?vue&type=template&id=31d269da"
import script from "./PDFTopic.vue?vue&type=script&lang=js"
export * from "./PDFTopic.vue?vue&type=script&lang=js"
import style0 from "./PDFTopic.vue?vue&type=style&index=0&id=31d269da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports